import React, { useState } from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { createAppQueryClient } from "./queryClient";

let sharedLazyRouteClient = null;

function getSharedLazyRouteClient() {
  if (!sharedLazyRouteClient) {
    sharedLazyRouteClient = createAppQueryClient();
  }
  return sharedLazyRouteClient;
}

/**
 * Provider for lazy-loaded route modules. When production code-splitting bundles a
 * second copy of @tanstack/react-query, hooks in that chunk cannot see the root
 * QueryClientProvider from index.js — this boundary colocates client + hooks.
 */
export function getLazyRouteQueryClient() {
  return getSharedLazyRouteClient();
}

export function ReactQueryBoundary({ children }) {
  const [client] = useState(getSharedLazyRouteClient);

  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}

export function withReactQueryBoundary(Component) {
  const Wrapped = (props) => (
    <ReactQueryBoundary>
      <Component {...props} />
    </ReactQueryBoundary>
  );
  Wrapped.displayName = `WithReactQueryBoundary(${
    Component.displayName || Component.name || "Component"
  })`;
  return Wrapped;
}
